export const attributesMapping = {
  institucion: 'institucion',
  abreviacion: 'abreviacion',
  tiene_mooc: 'tiene_mooc',
  plataforma: 'plataforma',
  dominio_aprendizaje: 'dominio_aprendizaje',
  tipo_institucion: 'tipo_institucion',
  titulo_mooc: 'titulo_mooc',
  dedicacion_horas_semanas: 'dedicacion_horas_semanas',
  duracion_semanas: 'duracion_semanas',
  idioma: 'idioma',
  mooc_spooc: 'mooc_spooc',
  url_mooc: 'url_mooc',
  site_url: 'site_url',
  provincia: 'provincia',
  provincia_codigo: 'provincia_codigo',
  anio: 'anio',
};

export interface Record {
  institucion: string;
  abreviacion: string,
  tiene_mooc: string,
  plataforma: string,
  dominio_aprendizaje: string,
  tipo_institucion: string,
  titulo_mooc: string,
  dedicacion_horas_semanas: string,
  duracion_semanas: string,
  idioma: string,
  mooc_spooc: string,
  url_mooc: string,
  site_url: string,
  provincia: string,
  provincia_codigo: string,
  anio: string,
}

export interface Record {
  institucion: string;
  abreviacion: string,
  tiene_mooc: string,
  plataforma: string,
  dominio_aprendizaje: string,
  tipo_institucion: string,
  titulo_mooc: string,
  dedicacion_horas_semanas: string,
  duracion_semanas: string,
  idioma: string,
  mooc_spooc: string,
  url_mooc: string,
  site_url: string,
  provincia: string,
  provincia_codigo: string,
  anio: string,
}